import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=2e6d499c&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=2e6d499c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6d499c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e6d499c')) {
      api.createRecord('2e6d499c', component.options)
    } else {
      api.reload('2e6d499c', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=2e6d499c&scoped=true&", function () {
      api.rerender('2e6d499c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26Y53V2d45JhP/JS/comp/GuestBox.vue"
export default component.exports